module.exports = __webpack_public_path__ + "assets/9b3e6193a08ce16b6fde6638fe65f9f0.mp3";